import { ComputedProperties, generateIndexDoc } from '../../ReplicantComputedProperties';
import type { Entry } from '../../db/DB';
import { deepEquals } from '../../utils/ObjUtils';

/** Resolves `operation` and if `operation` mutates any of the indexed state properties, returns the new index document. */
export async function withIndexDocGeneration(
    userId: string,
    entry: Entry<any>,
    config: { computedProperties?: ComputedProperties },
    dateNow: () => number,
    forceGeneration: boolean,
    operation: () => unknown,
): Promise<Record<string, unknown> | void> {
    if (forceGeneration) {
        await operation();
        return generateIndexDoc(userId, entry, config, dateNow);
    } else {
        const oldIndexDocTimestamp = Math.max(entry.lastMessageReceivedAt || 0, entry.lastUpdated);
        const oldIndexDoc = generateIndexDoc(userId, entry, config, () => oldIndexDocTimestamp);

        await operation();

        const newIndexDoc = generateIndexDoc(userId, entry, config, dateNow);

        if (!deepEquals(oldIndexDoc, newIndexDoc)) {
            return newIndexDoc;
        }
    }
}
